// Design tokens — mirrors kinetica.com brand system.
// Keep in sync with ./tokens.less (consumed by craco-less + AntD modifyVars).
// CommonJS export so this can be require()'d from craco.config.js.

const tokens = {
  brand: {
    50:  "#f5f3ff",
    100: "#ede9fe",
    200: "#ddd6fe",
    300: "#c4b5fd",
    400: "#a78bfa",
    500: "#8b5cf6", // primary
    600: "#7c3aed",
    700: "#6d28d9",
    800: "#5b21b6",
    900: "#4c1d95",
    950: "#2e1065",
  },
  accent: {
    400: "#ff5c8a",
    500: "#ff3366",
    600: "#e6174d",
  },
  surface: {
    50:  "#09090b", // page bg (darkest)
    100: "#111115", // card bg
    200: "#1c1c22", // elevated
    800: "#a1a1aa", // muted text
    900: "#e4e4e7", // secondary text
    950: "#fafafa", // primary text / foreground
  },
  border: {
    glow:      "rgba(255,255,255,0.08)",
    glowHover: "rgba(255,255,255,0.15)",
  },
  shadow: {
    card:          "0 1px 3px rgba(0,0,0,0.3), 0 1px 2px rgba(0,0,0,0.2)",
    cardHover:     "0 4px 12px rgba(0,0,0,0.4), 0 2px 4px rgba(0,0,0,0.3)",
    elevated:      "0 8px 24px rgba(0,0,0,0.5)",
    glowKinetica:  "0 0 20px rgba(124,58,237,0.25)",
  },
  font: {
    sans:  '"Inter", "Alliance No.1", ui-sans-serif, system-ui, sans-serif',
    serif: '"Instrument Serif", ui-serif, Georgia, serif',
    mono:  '"JetBrains Mono", ui-monospace, monospace',
    code:  '"Fira Code", "JetBrains Mono", ui-monospace, monospace',
  },
  radius: {
    sm: "4px",
    md: "6px",
    lg: "8px",
    xl: "12px",
  },
  semantic: {
    success: "#22c55e",
    warning: "#b5ff3d", // lime — used for non-prod env indicator
    danger:  "#ff3366", // matches accent-500
    info:    "#8b5cf6", // matches brand-500
  },
};

module.exports = tokens;
module.exports.default = tokens;
